<template>
  <div class="wrapper">
    <!-- <div class="row">
            <div class="col-md-5">
                <datepicker :bootstrap-styling="true" :use-utc="true" ></datepicker>
            </div>
            <div class="col-md-5">
                <datepicker :bootstrap-styling="true" :use-utc="true"></datepicker>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-primary" @click="fetchTimeReport">Apply</button>
            </div>
        </div> -->

    <div class="row" v-if="loaded">
      <h3>Time report</h3>
      <chart :chartData="timeChart"></chart>
    </div>
    <!-- <div class="row">
            <h3>Client report</h3>
            <chart  :chartData="timeChart"></chart>
        </div>
        <div class="row">
            <h3>Project report</h3>
        </div> -->
  </div>
</template>

<script setup>
import PlottedBarChart from "./charts/PlottedBarChart.vue";
import { brogglBack } from "../axios.js";
import { ref, reactive, onMounted } from "vue";
import dayjs from "dayjs";

let loaded = ref(false);
let token = window.$cookies.get("jwt");
let timeChart = reactive({
  labels: [],
  datasets: [
    {
      label: "Billable",
      fill: false,
      backgroundColor: "#0077ff",
      data: [],
    },
    {
      label: "Not-Billable",
      fill: false,
      backgroundColor: "#2ec0e7",
      data: [],
    },
    {
      label: "Internal",
      fill: false,
      backgroundColor: "#130df4",
      data: [],
    },
  ],
});

let clientChart = reactive({
  labels: [],
  datasets: [
    {
      label: "Billable",
      fill: false,
      backgroundColor: "#0077ff",
      data: [],
    },
    {
      label: "Not-Billable",
      fill: false,
      backgroundColor: "#2ec0e7",
      data: [],
    },
    {
      label: "Internal",
      fill: false,
      backgroundColor: "#130df4",
      data: [],
    },
  ],
});

const startDate = "01/12/2018";
const endDate = dayjs(new Date()).format("DD/MM/YYYY");

const fecthTimeReport = async () => {
  try {
    const res = await brogglBack.get("personnal-report-month", {
      headers: { Authorization: token },
      params: { start_date: startDate, end_date: endDate },
    });
    let dataBillable = [];
    let dataNotBillable = [];
    let dataInternal = [];
    let labels = [];
    let data = res.data.chart_data;
    let k = Object.keys(data);
    k.sort((a, b) => {
      return new Date(a) - new Date(b);
    });
    k.forEach((key) => {
      labels.push(key);
      dataBillable.push(data[key].billable);
      dataNotBillable.push(data[key].not_billable);
      dataInternal.push(data[key].internal);
    });
    timeChart.labels = labels;
    timeChart.datasets[0].data = dataBillable;
    timeChart.datasets[1].data = dataNotBillable;
    timeChart.datasets[2].data = dataInternal;
    loaded.value = true;
  } catch (error) {
    console.log(error);
  }
};

const fetchClientReport = async () => {
  try {
    const res = await brogglBack.get("personnal-report-project", {
      headers: { Authorization: token },
      params: {
        start_date: startDate,
        end_date: endDate,
        first_grouping: "client_name",
        second_grouping: "project",
      },
    });
  } catch (err) {
    console.log(err);
  }
};

onMounted(async () => {
  await fecthTimeReport();
  await fetchClientReport();
});
</script>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "PersonnalReports",
  components: {
    chart: PlottedBarChart,
  },
  data() {
    //   loaded: false,
    //   token: document.cookie.split('jwt=')[1],
    //   timeChart: {
    //     labels: [],
    //     datasets: [
    //       {
    //         label: 'Billable',
    //         fill: false,
    //         backgroundColor: '#0077ff',
    //         data: []
    //       },
    //       {
    //         label: 'Not-Billable',
    //         fill: false,
    //         backgroundColor: '#2ec0e7',
    //         data: []
    //       },
    //       {
    //         label: 'Internal',
    //         fill: false,
    //         backgroundColor: '#130df4',
    //         data: []
    //       }
    //     ]
    //   },
    //   clientChart: {
    //     labels: [],
    //     datasets: [
    //       {
    //         label: 'Billable',
    //         fill: false,
    //         backgroundColor: '#0077ff',
    //         data: []
    //       },
    //       {
    //         label: 'Not-Billable',
    //         fill: false,
    //         backgroundColor: '#2ec0e7',
    //         data: []
    //       },
    //       {
    //         label: 'Internal',
    //         fill: false,
    //         backgroundColor: '#130df4',
    //         data: []
    //       }
    //     ]
    //   }
    // }
    // },
    // beforeMount () {
    //   this.fetchTimeReport()
    //   this.fetchClientReport()
  },
  methods: {
    fetchTimeReport() {
      brogglBack
        .get("personnal-report-month", {
          headers: { Authorization: this.token },
          params: { start_date: "01/01/2018", end_date: "31/12/2019" },
        })
        .then((response) => {
          var dataBillable = [];
          var dataNonBillable = [];
          var dataInternal = [];
          var labels = [];
          this.projectData = response.data.project_data;
          var data = response.data.chart_data;
          var k = Object.keys(data);
          k.sort(function (a, b) {
            return new Date(a) - new Date(b);
          });
          for (var i = 0; i < k.length; i++) {
            dataBillable.push(data[k[i]]["billable"]);
            dataNonBillable.push(data[k[i]]["non_billable"]);
            dataInternal.push(data[k[i]]["internal"]);
            labels.push(data[k[i]]["month"]);
          }
          this.timeChart.datasets[0].data = dataBillable;
          this.timeChart.datasets[1].data = dataNonBillable;
          this.timeChart.datasets[2].data = dataInternal;
          this.timeChart.labels = labels;
          this.loaded = true;
        });
    },
    fetchClientReport() {
      brogglBack.get("personnal-report-project", {
        headers: { Authorization: this.token },
        params: {
          start_date: "01/12/2018",
          end_date: "31/12/2019",
          first_grouping: "client_name",
          second_grouping: "project",
        },
      });
    },
  },
});
</script>

<style scoped>
.wrapper {
  background-color: inherit;
}
</style>
